import React from 'react';
import Denuncia from '../../components/Denuncia';

const Home: React.FC = () => {
  return <Denuncia />;
};

export default Home;
